import { isStorageAvailable, StorageWrapper } from "utils/infrastructure/storage-util"

const PROMO_CODE_NAME: PromocodeNameType = "promo_code"
const BANNER_NAME = "discount-banner"

type PromocodeNameType = "promo_code"

declare global {
    interface Window {
        showPromoCodeBanner: (target: string) => void
    }
}

export type BannerConfigType = {
    hidden: boolean
}

export class BannerStorage {
    private static readonly storage = isStorageAvailable
        ? new StorageWrapper(window.localStorage)
        : undefined

    private static readonly defaultBannerConfig: BannerConfigType = {
        hidden: false,
    }

    static getPromoCode(): string | undefined {
        const value = this.storage?.getString<PromocodeNameType>(PROMO_CODE_NAME)
        if (value === null || value === undefined) return
        return value
    }

    static setPromoCode(value: string | undefined) {
        if (value === undefined) {
            this.storage?.remove(PROMO_CODE_NAME)
            return
        }
        this.storage?.storeString(PROMO_CODE_NAME, value)
    }

    static getBannerConfig(): BannerConfigType {
        return this.storage?.getObject<BannerConfigType>(BANNER_NAME) ?? this.defaultBannerConfig
    }

    static hideBanner() {
        this.storage?.store(
            BANNER_NAME,
            Object.assign({}, this.getBannerConfig(), { hidden: true })
        )
    }

    static setBannerShow() {
        this.storage?.store(
            BANNER_NAME,
            Object.assign({}, this.getBannerConfig(), { hidden: false })
        )
    }

    static reset() {
        this.storage?.store(BANNER_NAME, this.defaultBannerConfig)
        this.setPromoCode(undefined)
    }
}
